<template>
  <div>
    <!-- <div class="guide"></div> -->
    <div
      @dragover.prevent
      @dtagenter.prevent
      @drop      ="drop"
      :style     ="styleObject"
      class      ="object-board"
      :class     ="{ active: dragging || newIcon !== null }"
    >
    </div>
    <div>
      <object-icon
        v-for       ="(icon, index) in objects"
        :icon       ="icon"
        :key        ="index"
      />
      <object-card />
    </div>
  </div>
</template>

<script>
import ObjectIcon from './icon'
import ObjectCard from './card'
import { mapActions, mapGetters } from 'vuex'

// import timeLine from '@/assets/match_TimeLine_sample'

// const killTimeLine = []
// timeLine.frames.forEach(frame => {
//   frame.events.forEach(event => {
//     if (event.type === 'CHAMPION_KILL') killTimeLine.push(event)
//   })
// })
// console.log(killTimeLine)

export default {
  name: 'ObjectBoard',
  data () {
    return {
      newIcon  : null,
      dragging : null
    }
  },
  props    : ['id'],
  computed : {
    styleObject () {
      return {
        width  : '3000px',
        height : '3000px'
      }
    },
    ...mapGetters('object', [
      'objects'
    ])
  },
  mounted () {
    this.$eventHub.$on('object-pick', this.ui_objectPickHandler)
    this.$eventHub.$on('object-drag', this.ui_objectDragHandler)

    // test
    // killTimeLine.forEach((kill, index) => {
    //   this.addNewObject({
    //     id          : this.getUniqueString(),
    //     type        : 'icon',
    //     width       : 60,
    //     height      : 60,
    //     borderColor : kill.killerId < 6 ? 'green' : 'red',
    //     img         : '/static/img/vision-temp.png',
    //     iconId      : 999,
    //     scale       : 100,
    //     top         : (14980 - 600 - kill.position.y) / 10,
    //     left        : kill.position.x / 10
    //   })
    // })
  },
  components: {
    ObjectIcon,
    ObjectCard
  },
  methods: {
    ...mapActions('object', [
      'addNewObject'
    ]),
    drop (e) {
      if (this.newIcon != null) {
        this.newIcon.top  = e.offsetY - this.newIcon.height / 2
        this.newIcon.left = e.offsetX - this.newIcon.width / 2
        this.addNewObject(this.newIcon)
        this.newIcon      = null
      }
    },
    ui_objectPickHandler (object) {
      this.newIcon = object
    },
    ui_objectDragHandler (object) {
      this.dragging = object
    }
  },
  sockets: {
    object: {
      connect () {
        console.log('icon board connected')
      }
    }
  }
}
</script>

<style scoped>
.guide {
  border         : solid 1px red;
  position       : absolute;
  top            : 0;
  left           : 0;
  width          : 1487px;
  height         : 1498px;
  z-index        : 300;
  pointer-events : none;
  user-select    : none;
  background-size: 100%;
  /* background-image: URL('https://s3-us-west-1.amazonaws.com/riot-developer-portal/docs/map11.png'); */
}
.object-board {
  position       : absolute;
  top            : 0;
  left           : 0;
  z-index        : 500;
  pointer-events : none;
  user-select    : none;
}
.active {
  pointer-events : auto;
}
</style>



// WEBPACK FOOTER //
// src/components/object/content/index.vue